{
  "longPressMessage": "Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku"
}
